import { FormDocument } from './store/types';

export function findPageIdForSelection(doc: FormDocument, selectedIds: string[]): string | undefined {
  if (selectedIds.length > 0) {
    const owningPage = doc.pages.find((page) => page.elements.some((el) => selectedIds.includes(el.id)));
    if (owningPage) return owningPage.id;
  }
  return doc.pages[0]?.id;
}
